import { extend, $$ } from './HelperFunctions'

export class Form {
  constructor (selectors, classes) {
    this.selectors = extend({
      formReset: '[type=reset]',
      formInput: '[data-js-form-input]'
    }, selectors)

    this.classes = extend({
      filled: 'form__field--filled'
    }, classes)
  }

  init () {
    this.addFormFieldFilledEvent()
    this.addResetFormEvent()
  }

  addFormFieldFilledEvent () {
    const that = this
    const formFields = $$(that.selectors.formInput)

    formFields.forEach(field => {
      checkInputValue(field)

      field.addEventListener('focus', () => {
        field.parentNode.classList.add(that.classes.filled)
      })

      field.addEventListener('blur', () => {
        checkInputValue(field)
      })
    })

    function checkInputValue (input) {
      const inputFilledClass = that.classes.filled

      if (input.value.length) {
        input.parentNode.classList.add(inputFilledClass)
      } else {
        input.parentNode.classList.remove(inputFilledClass)
      }
    }
  }

  addResetFormEvent () {
    const that = this
    const formResets = $$(that.selectors.formReset)

    formResets.forEach(reset => {
      reset.addEventListener('click', () => {
        const form = reset.parentNode.closest('form')
        const formInputs = $$('input, textarea, select', form)
        formInputs.forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false
          } else {
            input.value = ''
            input.parentNode.classList.remove(that.classes.filled)
          }
        })
      })
    })
  }
}

export default Form
